"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountColors = void 0;
exports.accountColors = [
    "blue",
    "light-blue",
    "green",
    "red",
    "orange",
    "yellow",
    "purple",
    "pink",
    "teal",
    "grey",
    "washed-blue",
    "washed-light-blue",
    "washed-green",
    "washed-red",
    "washed-orange",
    "washed-yellow",
    "washed-purple",
    "washed-pink",
    "washed-teal",
    "washed-grey",
];
